<nav
  class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white navbar-admin-console"
>
  <div class="container">
    <div class="col">
      <img
        src="../../../assets/images/lighthouse-logo.svg"
        class="LightHouse-Logo"
        alt=""
      />
    </div>
  </div>
</nav>
